module.exports = __webpack_public_path__ + "static/media/image_44.2c020aad.png";